module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-be.aba3541b.png";